<template>
  <div class="rightBox">
    <div class="cockpitBox">
      <div class="cockpit_header">
        <div class="cockpit_header_bg">
          <div>
            <img :src="require('@/assets/img/cockpit/deng.png')" alt />
          </div>
          <div class="header_title">项目投诉</div>
          <div>
            <img :src="require('@/assets/img/cockpit/dian.png')" alt />
          </div>
        </div>
      </div>
      <div class="cockpit_content">
        <div class="row_box">
          <div class="row_box_absolute"></div>
          <img :src="require('@/assets/img/cockpit/warn/right1.png')" alt />
          <div class="row_box_dec">待受理</div>
          <div class="row_box_val">
            <span>
              <span>{{ dealStatus('待受理') }}</span>
            </span>
            条
          </div>
        </div>
        <div class="row_box">
          <div class="row_box_absolute"></div>
          <img :src="require('@/assets/img/cockpit/warn/right2.png')" alt />
          <div class="row_box_dec">已受理</div>
          <div class="row_box_detail">
            <div class="row_box_detail_row">
              <span></span> 已办结
              <span>&nbsp;{{ countArr['已办结'] }}</span>
            </div>
            <div class="row_box_detail_row">
              <span></span> 未办结
              <span>&nbsp;{{ countArr['未办结'] }}</span>
            </div>
            <div class="row_box_detail_row">
              <span></span> 已失效
              <span>&nbsp;{{ countArr['已失效'] }}</span>
            </div>
          </div>
          <div class="row_box_val row_box_green">
            <span>{{ dealStatus('已受理') }}</span>
            条
          </div>
        </div>
        <div class="row_box">
          <div class="row_box_absolute"></div>
          <img :src="require('@/assets/img/cockpit/warn/right3.png')" alt />
          <div class="row_box_dec">不予受理</div>
          <div class="row_box_val row_box_gray">
            <span>
              <span>{{ dealStatus('不予受理') }}</span>
            </span>
            条
          </div>
        </div>
        <div style="margin-top:34px">
          <div class="cockpit_content_boxHeader">
            <div class="header_cicle">
              <img :src="require('@/assets/img/cockpit/cicle.png')" alt />
            </div>
            <div class="header_decrit">项目类型分布</div>
            <div class="header_line"></div>
            <div class="header_sanjiao">
              <img :src="require('@/assets/img/cockpit/sanjiao.png')" alt />
            </div>
          </div>
          <div class="cockpit_content_boxContent distribution">
            <div id="echartsData1"></div>
            <div class="rightFrequency">
              <div class="rightFrequency_box" v-for="(item, index) in listData" :key="index">
                <div :style="{ 'background': colorList[index] }"></div>
                <div>{{ item.name }}</div>
                <div>{{ total > 0 ? (((item.value / total) * 100).toFixed(2)) + '%' : 0 + '%' }}</div>
              </div>
            </div>
          </div>
        </div>
        <el-carousel class="complaints_box" style="display: none;">
          <el-carousel-item v-for="(item, index) in complaintsData" :key="index">
            <div class="complaints_list" @click="jumpComplaintsData(item)">
              <div class="complaints_head">
                <img src="@/assets/img/cockpit/warn/su.png" alt />
                <div>{{ item.bidSectionCode }}</div>
              </div>
              <div class="complaints_cotent">
                <div class="content-title">{{ item.bidSectionName }}</div>
                <div class="content-flex-row">
                  <span>
                    <icon-svg name="code"></icon-svg>
                  </span>
                  <span>投诉编号</span>
                  <span>{{ item.complaintCode }}</span>
                </div>
                <div class="content-flex-row">
                  <span>
                    <icon-svg name="time"></icon-svg>
                  </span>
                  <span>投诉时间</span>
                  <span>{{ item.submitTime }}</span>
                </div>
                <div class="content-flex-row">
                  <span>
                    <icon-svg name="laiyuan"></icon-svg>
                  </span>
                  <span>投诉来源</span>
                  <span>{{ item.sourceTypeName }}</span>
                </div>
                <div class="content-flex-row">
                  <span>
                    <icon-svg name="users"></icon-svg>
                  </span>
                  <span>投诉人员</span>
                  <span>{{ item.complainter }}</span>
                </div>
                <div class="content-flex-row">
                  <span>
                    <icon-svg name="renyuan"></icon-svg>
                  </span>
                  <span>被投诉人</span>
                  <!-- <div class="right_card">
                    <p
                      v-for="(items, indexs) in item.complaintAppellees"
                      :key="indexs"
                      style="margin-bottom:10px"
                    >
                        {{ items.entName }}（主体类别：{{ items.mainTypeName }}）
                    </p>
                  </div>-->

                  <div class="right_card">
                    <el-tooltip placement="top">
                      <div slot="content">
                        <p
                          v-for="(items, indexs) in item.complaintAppellees"
                          :key="indexs"
                          style="margin-bottom:10px"
                        >{{ items.entName }}（主体类别：{{ items.mainTypeName }}）</p>
                      </div>
                      <p
                        v-for="(items, indexs) in item.complaintAppellees"
                        :key="indexs"
                        class="textOver"
                      >{{ items.entName }}（主体类别：{{ items.mainTypeName }}）</p>
                    </el-tooltip>
                  </div>
                </div>
                <template v-if="item.receiveStatus == 1">
                  <img src="@/assets/img/complaint/dsl.png" />
                </template>
                <template v-else-if="item.receiveStatus == 2">
                  <img src="@/assets/img/complaint/bysl.png" />
                </template>
                <template v-else>
                  <img src="@/assets/img/complaint/ysl.png" />
                </template>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts/core";
import { BarChart, ScatterChart, PieChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  DatasetComponentOption,
  TransformComponent,
  LegendComponent
} from "echarts/components";
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from "echarts/features";
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from "echarts/renderers";
import vueSeamlessScroll from "vue-seamless-scroll";
// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  PieChart,
  ScatterChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  LegendComponent
]);
export default {
  data() {
    return {
      listData: {},
      unit: "",
      times: "",
      activeIndex: "",
      complaintsData: [],
      colorList: [
        "#159AFF",
        "#D4DEEB",
        "#9BF6B9",
        "#D3E46B",
        "#15C7FF",
        "#9BDDDD",
        "#366AED",
        "#ECBA5A",
        "#61CF4F",
        "#CC8DEA"
      ],
      countArr: {},
      countArr1: [],
      total: 0
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getComplaintData();
    },
    getComplaintData() {
      //获取投诉数据
      this.$httpReq({
        url: "/homePage/listComplaint",
        method: "post",
        data: {
          page: 1,
          rows: 999,
          filter: {}
        }
      }).then(({ data }) => {
        this.complaintsData = data.rows;
      });

      this.$httpReq({
        //投诉项目类型分布
        url: `/complaint/stat/projectType`,
        method: "post"
      }).then(({ data }) => {
        if (data.code == 1) {
          this.listData = data.data;
          for (var i in data.data) {
            this.total += data.data[i].value;
          }
          this.getPieData(data.data);
        } else {
          this.$message.error(data.msg);
        }
      });

      this.$httpReq({
        //获取待受理投诉数据
        url: "/complaint/endStatusList",
        method: "post"
      }).then(({ data }) => {
        if (data.code == 1) {
          this.countArr = data.data;
        }
      });

      this.$httpReq({
        //获取待受理投诉数据
        url: "/complaint/stat/receiveResult?type=all",
        method: "post",
        data:{  superviseDeptCodeList:[]}
      }).then(({ data }) => {
        if (data.code == 1) {
          this.countArr1 = data.data;
        }
      });
    },
    getPieData(data) {
      let colorList = this.colorList;
      let leftCenter = ["50%", "48%"];
      var option = {
        tooltip: {
          trigger: "item"
        },
        series: [
          // 左饼图
          {
            // 饼图圈
            hoverAnimation: false,
            type: "pie",
            zlevel: 3,
            radius: ["79%", "65%"],
            center: leftCenter,
            itemStyle: {
              normal: {
                borderColor: "#162D50",
                borderWidth: 5,
                color: function(params) {
                  return colorList[params.dataIndex];
                }
              }
            },
            labelLine: {
              show: false
            },
            label: {
              show: false
            },
            data: data
          },
          {
            // 最外圆圈
            type: "pie",
            zlevel: 1,
            silent: true, //取消高亮
            radius: ["88%", "85%"],
            center: leftCenter,
            itemStyle: {
              normal: {
                show: false,
                color: "#273D5D"
              }
            },
            labelLine: {
              show: false
            },
            label: {
              show: false
            },
            data: [100]
          },
          {
            name: "",
            type: "pie",
            color: "#999",
            radius: ["60%", "58%"],
            center: leftCenter,
            hoverAnimation: false,
            silent: true, //取消高亮
            itemStyle: {
              normal: {
                color: "#4B607B"
              }
            },
            zlevel: 1,
            labelLine: {
              show: false
            },
            data: [100]
          },
          {
            // 饼图圈
            hoverAnimation: false,
            type: "pie",
            zlevel: 3,
            radius: ["45%", "35%"],
            center: leftCenter,
            itemStyle: {
              normal: {
                borderColor: "#162D50",
                borderWidth: 5,
                color: function(params) {
                  return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#162D51"
                    },
                    {
                      offset: 0.3,
                      color: "#162D51"
                    },
                    {
                      offset: 1,
                      color: colorList[params.dataIndex]
                    }
                  ]);
                }
              }
            },
            labelLine: {
              show: false
            },
            label: {
              show: false
            },
            data: data
          },
          {
            // 饼图圈
            hoverAnimation: false,
            type: "pie",
            zlevel: 1,

            radius: ["20%", "15%"],
            center: leftCenter,
            itemStyle: {
              normal: {
                borderColor: "#162C4E",
                borderWidth: 2,
                color: "#6C8097"
              }
            },
            labelLine: {
              show: false
            },
            label: {
              show: false
            },
            data: [20, 20, 20, 20]
          },
          {
            name: "",
            type: "pie",
            color: "#999",
            radius: ["11%", "9%"],
            center: leftCenter,
            hoverAnimation: false,
            silent: true, //取消高亮
            itemStyle: {
              normal: {
                color: "#6C8097"
              }
            },
            zlevel: 1,
            labelLine: {
              show: false
            },
            data: [100]
          }
        ]
      };
      var myChart = document.getElementById("echartsData1");
      let chartBox = echarts.init(myChart);
      chartBox.setOption(option);
      window.addEventListener("resize", () => {
        chartBox.resize();
      });
    },
    dealStatus(name) {
      //处理受理数据值
      var data = this.countArr1.filter(ele => {
        return ele.name == name;
      });
      if (data.length > 0) {
        return data[0].value;
      }
      return 0;
    },
    jumpComplaintsData(row) {
      removeTabHandle("offline_complaints");
      // this.$router.push({
      //     name:'offline_complaints',
      //     query:{id:row.id,code:row.complaintCode}
      // })
      window.opener.postMessage(
        {
          type: true,
          url: "offline_complaints",
          parent: "online_complaints_list",
          query: { id: row.id, code: row.complaintCode }
        },
        "*"
      );
      window.close();
      sessionStorage.setItem("oneliner", JSON.stringify(row));
    }
  }
};
</script>
<style lang="scss" scoped>
.rightBox {
  width: 100%;

  .cockpit_content {
    margin-top: 24px;
  }

  .row_box {
    width: 480px;
    height: 68px;
    margin-left: 24px;
    display: flex;
    align-items: center;
    position: relative;

    &:nth-of-type(2) {
      margin: 24px 0 24px 24px;
    }

    img {
      margin-left: 16px;
    }

    .row_box_absolute {
      position: absolute;
      height: 48px;
      width: 100%;
      top: 24px;
      background: linear-gradient(
        0deg,
        rgba(24, 144, 255, 0.25) 0%,
        rgba(24, 144, 255, 0) 100%
      );
    }

    .row_box_dec {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.85);
      margin-left: 22px;
    }

    .row_box_val {
      margin-left: auto;
      color: #9fc4e4;
      margin-right: 18px;

      span {
        font-size: 32px;
        display: inline-block;
        background: linear-gradient(100deg, #feaf36 0%, #fad57a 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-right: 12px;
      }
    }

    .row_box_green {
      span {
        background: linear-gradient(244deg, #c0f0a3 0%, #65cd58 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-right: 12px;
      }
    }

    .row_box_gray {
      span {
        background: none;
        -webkit-text-fill-color: #9fc4e4;
        color: #9fc4e4;
      }
    }

    .row_box_detail {
      display: flex;
      align-items: center;
      margin-left: 22px;

      .row_box_detail_row {
        color: rgba(255, 255, 255, 0.85);
        display: flex;
        align-items: center;
        margin-right: 12px;
        font-size: 12px;

        & > span:nth-of-type(1) {
          display: inline-block;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          margin-right: 6px;
        }

        &:nth-of-type(1) {
          & > span {
            color: #65cc57;

            &:nth-of-type(1) {
              background-color: #65cc57;
            }
          }
        }

        &:nth-of-type(2) {
          & > span {
            color: #facc14;

            &:nth-of-type(1) {
              background-color: #facc14;
            }
          }
        }

        &:nth-of-type(3) {
          & > span {
            color: #ef4864;

            &:nth-of-type(1) {
              background-color: #ef4864;
            }
          }
        }
      }
    }
  }

  .complaints_box {
    margin-left: 16px;
    height: 294px;
    overflow: hidden;
  }

  .complaints_list {
    width: 497px;
    height: 294px;
    background: rgba(24, 144, 255, 0.25);
    font-size: 14px;
    box-shadow: 0px 0px 8px 0px rgba(72, 92, 109, 0.2);
    border-radius: 4px;
    margin-bottom: 16px;
    position: relative;
    margin-top: 3px;

    &:nth-of-type(2n-1) {
      margin-right: 16px;
    }
  }

  .complaints_head {
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 1);
    background: linear-gradient(
      270deg,
      rgba(255, 228, 0, 0.1) 0%,
      #ffc500 100%
    );
    border-radius: 2px 2px 0px 0px;
    height: 36px;

    img {
      margin-left: 6px;
      margin-right: 6px;
    }
  }

  .complaints_cotent {
    position: relative;
    padding-top: 12px;
    padding-left: 17px;

    .content-title {
      width: calc(100% - 34px);
      font-weight: 600;
      line-height: 20px;
      height: 40px;
      color: rgba(255, 255, 255, 0.85);
      margin-bottom: 15px;
    }

    .content-flex-row {
      display: flex;
      height: 30px;
      align-items: center;
      color: rgba(255, 255, 255, 0.75);
      width: 100%;

      span {
        display: inline-block;
      }

      span:nth-of-type(1) {
        // width: 12px;
      }

      span:nth-of-type(2) {
        margin: 0 16px 0 5px;
        width: 68px;
      }

      span:nth-of-type(3) {
        width: calc(100% - 100px);
        line-height: 20px;
      }

      &:nth-of-type(6) {
        height: 140px;
        margin-top: 7px;
        align-items: flex-start;
      }

      .right_card {
        width: calc(100% - 68px);
        /* 这里是超出几行省略 */
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        .textOver {
          margin-bottom: 10px;
          margin-right: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          line-clamp: 2;
        }
      }
    }

    img {
      position: absolute;
      top: 18px;
      right: 30px;
    }
  }

  /deep/ .el-carousel__indicators {
    display: none;
  }

  .cockpit_content_boxContent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 10px;
    // height: 234px;
    height: 550px;

    #echartsData1 {
      height: 216px;
      width: 216px;
    }

    .rightFrequency {
      width: calc(100% - 226px);
      margin-right: 45px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .rightFrequency_box {
        width: 125px;
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        height: 24px;
        background-color: rgba(24, 144, 255, 0.1);
        font-size: 12px;

        & > div {
          &:nth-of-type(1) {
            width: 9px;
            height: 9px;
            margin-left: 8px;
          }

          &:nth-of-type(2) {
            font-size: 12px;
            margin: 0 0px 0 8px;
            color: #9fc4e4;
          }

          &:nth-of-type(3) {
            margin-left: auto;
            margin-right: 5px;
            color: #9fc4e4;
          }
        }
      }
    }
  }
}
</style>